/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import PropTypes from 'prop-types';
import MomentUtils from '@date-io/moment';

const DatePickerField = ({
  dateParser,
  input,
  label,
  dateFormatter,
  defaultValue,
  ...rest
}) => {
  const getDate = () => {
    if (defaultValue) {
      return defaultValue;
    }
    return new Date();
  };
  const { onChange } = input;
  const [selectedDate, setSelectedDate] = React.useState(getDate());

  return (
    <MuiPickersUtilsProvider
      locale="fr"
      utils={MomentUtils}
    >
      <KeyboardDateTimePicker
        variant="inline"
        inputVariant="outlined"
        defaultValue={defaultValue}
        label={label}
        format="DD/MM/yyyy"
        value={selectedDate}
        onChange={(val) => { setSelectedDate(val); onChange(val._d); }}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        autoOk
        {...rest}
      />
    </MuiPickersUtilsProvider>
  );
};

DatePickerField.propTypes = {
  dateParser: PropTypes.any.isRequired,
  input: PropTypes.any.isRequired,
  label: PropTypes.any.isRequired,
  dateFormatter: PropTypes.any.isRequired,
  defaultValue: PropTypes.any.isRequired,
};

export default DatePickerField;
